import { render } from "./BarsTab.vue?vue&type=template&id=5fb10db0&scoped=true&ts=true"
import script from "./BarsTab.vue?vue&type=script&lang=ts"
export * from "./BarsTab.vue?vue&type=script&lang=ts"

import "./BarsTab.vue?vue&type=style&index=0&id=5fb10db0&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb10db0"]])

export default __exports__